import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { SERVER_URL } from "../constants/variables";
import ayekartLogo from "../assets/images/ayekartLogo.png";
import { Mail, ArrowLeft, Send } from "lucide-react";
import "./ForgotPasswordComponent.css";

export default class ForgotPasswordComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onSubmit = () => {
    const email = this.state.email.trim();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    toast.loading("Sending reset link...", { duration: 2000 });
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    };
    fetch(SERVER_URL + "/users/forgot-password", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          toast.success(result.message);
          this.setState({ email: "" });
        } else {
          toast.error(result.message || "Something went wrong");
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
      });
  };

  render() {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-card">
          <div className="forgot-password-logo-container">
            <img src={ayekartLogo} alt="Ayekart Logo" />
          </div>
          
          <div className="forgot-password-header">
            <div className="forgot-password-icon-wrapper">
              <Mail size={32} strokeWidth={2} />
            </div>
            <h2 className="forgot-password-title">Forgot Password?</h2>
            <p className="forgot-password-subtitle">
              No worries! Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          <Form onSubmit={(e) => { e.preventDefault(); this.onSubmit(); }}>
            <FormGroup className="forgot-password-form-group">
              <Label for="email" className="forgot-password-label">
                Email Address
              </Label>
              <div className="forgot-password-input-wrapper">
                <Mail size={18} className="forgot-password-input-icon" />
                <Input
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  type="email"
                  className="forgot-password-input"
                  value={this.state.email}
                  onChange={this.handleInputChange}
                />
              </div>
            </FormGroup>

            <Button 
              type="submit"
              className="forgot-password-button"
              onClick={this.onSubmit}
            >
              <Send size={18} />
              <span>Send Reset Link</span>
            </Button>

            <div className="forgot-password-back-link">
              <Link to="/login" className="forgot-password-back">
                <ArrowLeft size={16} />
                <span>Back to Login</span>
              </Link>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}
